import { useState } from "react";
import { Colors } from "../../../../utils/colors/colors";
import { useExportResumeToCSV } from "../../../../hooks/apis/useResumeClinic.api";
import ButtonComponent from "../../../../utils/button/ButtonComponent";
import styled from "styled-components";



/**
 * @description A component that renders a summary of the open forum event
 * registration, including total RSVPs, total attendees, and percentage of
 * attendees. Also includes a button to delete all RSVPs and a button to
 * export all RSVPs to a CSV file.
 * @param {object} data The data object containing RSVP information.
 * @returns A JSX component that renders the RSVP summary.
 */
const ResumeSummary = ({ data }) => {
  const { primaryColor, dangerColor } = Colors();
  const [isDownloading, setIsDownloading] = useState(false);

  const { refetch } = useExportResumeToCSV();

  const handleExportCSV = async () => {
    setIsDownloading(true); // Set loading state
    try {
      const response = await refetch(); // Manually trigger API call
      const csvData = response.data; // Get CSV content

      if (!csvData) {
        console.error("No CSV data received");
        return;
      }

      // Convert response data into CSV file for download
      const blob = new Blob([csvData], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      // Create a temporary link and trigger download
      const a = document.createElement("a");
      a.href = url;
      a.download = "RSVP_Export.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error exporting CSV:", error);
    } finally {
      setIsDownloading(false); // Reset state after download
    }
  };

  const totalRsvp = data?.total || 0;


  return (
    <ResumeSummaryWrapper>

      <BtnWrapper>
        <ButtonComponent
          bgColor={dangerColor}
          text={"DELETE ALL"}
          click={() => { }}
          isLoading={true}
        />

        <ButtonComponent
          bgColor={primaryColor}
          text={"EXPORT ALL"}
          click={handleExportCSV}
          isLoading={isDownloading}
        />
      </BtnWrapper>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "2rem",
        }}
      >
        <ResumeSummaryMainWrapper>
          <TotalRsvpWrapper>
            <SummaryTerm>Total RSVP</SummaryTerm>
            <SummaryValue>{totalRsvp}</SummaryValue>
          </TotalRsvpWrapper>

        </ResumeSummaryMainWrapper>
      </div>

    </ResumeSummaryWrapper>
  );
};

export default ResumeSummary;

const ResumeSummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 3rem;
  background-color: #ffffff;
  height: 100%;


  @media (min-width: 568px) {
    align-items: flex-end;
  }
`;

const ResumeSummaryMainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 60px;

  @media (min-width: 568px) {
    flex-direction: row;
    margin-bottom: 0;
  }
`;

const TotalRsvpWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px;
  gap: 10px;
  width: 192px;
  height: 147px;
  background: #4f4f4f;
  border-radius: 30px;
`;

const SummaryTerm = styled.p`
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
  color: #ffffff;
  padding: 0;
  margin: 0;
`;

const SummaryValue = styled.p`
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 42px;
  line-height: 140%;
  color: #ffffff;
  padding: 0;
  margin: 0;
`;


const BtnWrapper = styled.div`
  display: flex;
  gap: 15px;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  @media (min-width: 568px) {
    align-items: flex-end;
    justify-content: flex-end;
    gap: 40px;
  }
`;
